import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { DragDropContext, Draggable } from "@hello-pangea/dnd";
import { StrictModeDroppable as Droppable } from "../../helpers/StrictModeDroppable";
import axios from '../../api/axios';
import styles from './Admin.module.css';
import LoadingModal from "../LoadingModal";
import { Link } from "react-router-dom";
import _ from "lodash";

const defaultStatements = [
	{
		displayOrder: 1,
		text: "Statement 1"
	},
	{
		displayOrder: 2,
		text: "Statement 2"
	}
]
const defaultAnswerChoices = [
	{
		displayOrder: 1,
		text: "Anwer choice 1"
	},
	{
		displayOrder: 2,
		text: "Anwer choice 2"
	}
];

const validTextRegex = /(.|\s)*\S(.|\s)*/

const EditMatrix = () => {

	const navigate = useNavigate();

	let { questionId } = useParams();

	const [text, setText] = useState("");
	const [shuffleStatements, setShuffleStatements] = useState(false);
	const [feature, setFeature] = useState(true);
	const [priority, setPriority] = useState(1);
	const [status, setStatus] = useState("active");
	const [statements, setStatements] = useState([...defaultStatements]);
	const [answerChoices, setAnswerChoices] = useState([...defaultAnswerChoices]);

	const [textCopy, setTextCopy] = useState("");
	const [shuffleStatementsCopy, setShuffleStatementsCopy] = useState(false);
	const [featureCopy, setFeatureCopy] = useState(true);
	const [priorityCopy, setPriorityCopy] = useState(1);
	const [statusCopy, setStatusCopy] = useState("active");
	const [statementsCopy, setStatementsCopy] = useState([...defaultStatements]);
	const [answerChoicesCopy, setAnswerChoicesCopy] = useState([...defaultAnswerChoices]);

	const [activeAnswerChoices, setActiveAnswerChoices] = useState(0);
	const [activeStatements, setActiveStatements] = useState(0);

	const [validAnswerChoices, setValidAnswerChoices] = useState(0);
	const [validStatements, setValidStatements] = useState(0);
	const [validQuestion, setValidQuestion] = useState(false);

	const [isSaving, setIsSaving] = useState(false);
	const [dataLoaded, setDataLoaded] = useState(questionId ? false : true);

	// const axiosPrivate = useAxiosPrivate();
	// const navigate = useNavigate();
	// const location = useLocation();

	const parseResponse = (response) => {
		if (response && response.data) {

			console.log(JSON.stringify(response.data));

			setText(response.data.text);
			setShuffleStatements(response.data.shuffleStatements);
			setFeature(response.data.feature);
			setPriority(response.data.priority);
			setStatus(response.data.status);
			setStatements(_.cloneDeep(response.data.statements));
			setAnswerChoices(_.cloneDeep(response.data.answerChoices));

			setTextCopy(response.data.text);
			setShuffleStatementsCopy(response.data.shuffleStatements);
			setFeatureCopy(response.data.feature);
			setPriorityCopy(response.data.priority);
			setStatusCopy(response.data.status);
			setStatementsCopy(_.cloneDeep(response.data.statements));
			setAnswerChoicesCopy(_.cloneDeep(response.data.answerChoices));

			setIsSaving(false);
			setDataLoaded(true);
		} else {
			console.log("Error: response is not valid");
		}
	}

	const onStatementChange = (index, text) => {
		setStatements(prev => prev.with(index, { ...prev[index], text: text }));
	}
	const onAnswerChoiceChange = (index, text) => {
		setAnswerChoices(prev => prev.with(index, { ...prev[index], text: text }));
	}
	const onDeleteStatement = (index) => {
		// if this hasn't been saved to the databse (matrixStatementId is undefined), and no text has been set, delete it altogether
		if ((statements[index].matrixStatementId === undefined) && (statements[index].text === "")) {
			setStatements(prev => prev.toSpliced(index, 1));
		} else {
			const deleted = (statements[index].deleted === true ? false : true);
			setStatements(prev => prev.with(index, { ...prev[index], deleted: deleted }));
		}
	}
	const onDeleteAnswerChoice = (index) => {
		// if this hasn't been saved to the databse (matrixAnswerChoiceId is undefined), and no text has been set, delete it altogether
		if ((answerChoices[index].matrixAnswerChoiceId === undefined) && (answerChoices[index].text === "")) {
			setAnswerChoices(prev => prev.toSpliced(index, 1));
		} else {
			const deleted = (answerChoices[index].deleted === true ? false : true);
			setAnswerChoices(prev => prev.with(index, { ...prev[index], deleted: deleted }));
		}
	}
	const onAddStatement = () => {

		const newStatements = _.cloneDeep(statements);

		let
			max,
			i, l;

		max = 0;

		for (i = 0, l = newStatements.length; i < l; i++) {
			max = Math.max(max, newStatements[i].displayOrder);
		}

		newStatements.push({
			displayOrder: max + 1,
			text: ""
		})

		setStatements(newStatements);
	}
	const onAddAnswerChoice = () => {
		const newAnswerChoices = _.cloneDeep(answerChoices);

		let
			max,
			i, l;

		max = 0;

		for (i = 0, l = newAnswerChoices.length; i < l; i++) {
			max = Math.max(max, newAnswerChoices[i].displayOrder);
		}

		newAnswerChoices.push({
			displayOrder: max + 1,
			text: ""
		})

		setAnswerChoices(newAnswerChoices);
	}

	const handleStatementOnDragEnd = (result) => {
		if (!result?.destination) return;

		const newStatements = _.cloneDeep(statements);

		const [reorderedStatement] = newStatements.splice(result.source.index, 1);

		newStatements.splice(result.destination.index, 0, reorderedStatement);

		console.log(newStatements);

		setStatements(newStatements);

	}

	const handleAnswerChoiceOnDragEnd = (result) => {
		if (!result?.destination) return;

		const newAnswerChoices = _.cloneDeep(answerChoices);

		const [reorderedAnswerChoice] = newAnswerChoices.splice(result.source.index, 1);

		newAnswerChoices.splice(result.destination.index, 0, reorderedAnswerChoice);

		setAnswerChoices(newAnswerChoices);

	}

	const saveChanges = () => {
		if (questionId === undefined) {
			saveNewMatrix();
		} else {
			saveUpdatedMatrix();
		}
	}

	const saveUpdatedMatrix = async () => {
		if (!validQuestion || (validAnswerChoices < 2) || (validStatements < 2)) {
			return;
		}

		let
			displayOrder;

		const statementsToDelete = [];
		const statementsToUpdate = [];
		const statementsToInsert = [];

		displayOrder = 0;

		for (let statement of statements) {
			if ((statement.deleted === true) && (statement.matrixStatementId !== undefined)) {
				statementsToDelete.push({ matrixStatementId: statement.matrixStatementId });
			} else {
				displayOrder++;
				statement.displayOrder = displayOrder;
				if (statement.matrixStatementId === undefined) {
					statementsToInsert.push(statement);
				} else {
					for (let copy of statementsCopy) {
						if (statement.matrixStatementId === copy.matrixStatementId) {
							if ((statement.displayOrder !== copy.displayOrder) || (statement.text !== copy.text)) {
								statementsToUpdate.push(statement);
							}
						}
					}
				}
			}
		};

		const answerChoicesToDelete = [];
		const answerChoicesToUpdate = [];
		const answerChoicesToInsert = [];

		displayOrder = 0;

		for (let answerChoice of answerChoices) {
			if ((answerChoice.deleted === true) && (answerChoice.matrixAnswerChoiceId !== undefined)) {
				answerChoicesToDelete.push({ matrixAnswerChoiceId: answerChoice.matrixAnswerChoiceId });
			} else {
				displayOrder++;
				answerChoice.displayOrder = displayOrder;
				if (answerChoice.matrixAnswerChoiceId === undefined) {
					answerChoicesToInsert.push(answerChoice);
				} else {
					for (let copy of answerChoicesCopy) {
						if (answerChoice.matrixAnswerChoiceId === copy.matrixAnswerChoiceId) {
							if ((answerChoice.displayOrder !== copy.displayOrder) || (answerChoice.text !== copy.text)) {
								answerChoicesToUpdate.push(answerChoice);
							}
						}
					}
				}
			}
		};

		const json = {};

		json.text = text;
		json.shuffleStatements = shuffleStatements;
		json.feature = feature;
		json.priority = priority;
		json.status = status;
		json.statementsToDelete = _.cloneDeep(statementsToDelete);
		json.statementsToUpdate = _.cloneDeep(statementsToUpdate);
		json.statementsToInsert = _.cloneDeep(statementsToInsert);
		json.answerChoicesToDelete = _.cloneDeep(answerChoicesToDelete);
		json.answerChoicesToUpdate = _.cloneDeep(answerChoicesToUpdate);
		json.answerChoicesToInsert = _.cloneDeep(answerChoicesToInsert);

		if (
			(text !== textCopy) ||
			(shuffleStatements !== shuffleStatementsCopy) ||
			(feature !== featureCopy) ||
			(priority !== priorityCopy) ||
			(status !== statusCopy) ||
			(statementsToDelete.length > 0) ||
			(statementsToUpdate.length > 0) ||
			(statementsToInsert.length > 0) ||
			(answerChoicesToDelete.length > 0) ||
			(answerChoicesToUpdate.length > 0) ||
			(answerChoicesToInsert.length > 0)
		) {
			setIsSaving(true);
			try {
				const response = await axios.patch(`/matrixes/${questionId}`,
					JSON.stringify(json),
					{
						headers: { 'Content-Type': 'application/json' }
					}
				);

				parseResponse(response);

			} catch (err) {
				console.log(err);
				// if (!err?.response) {
				//     setErrMsg('No Server Response');
				// } else if (err.response?.status === 409) {
				//     setErrMsg('Email Taken');
				// } else {
				//     setErrMsg('Registration Failed')
				// }
				// errRef.current.focus();
			}

		}

	}
	const saveNewMatrix = async () => {
		if (!validQuestion || (validAnswerChoices < 2) || (validStatements < 2)) {
			return;
		}

		let
			displayOrder;

		const statementsToInsert = [];

		displayOrder = 0;

		for (let statement of statements) {
			displayOrder++;
			statement.displayOrder = displayOrder;
			statementsToInsert.push({
				displayOrder: displayOrder,
				text: statement.text
			});
		};

		const answerChoicesToInsert = [];

		displayOrder = 0;

		for (let answerChoice of answerChoices) {
			displayOrder++;
			answerChoice.displayOrder = displayOrder;
			answerChoicesToInsert.push({
				displayOrder: displayOrder,
				text: answerChoice.text
			});
		};

		const json = {};

		json.text = text;
		json.shuffleStatements = shuffleStatements;
		json.feature = feature;
		json.priority = priority;
		json.status = status;
		json.statements = _.cloneDeep(statementsToInsert);
		json.answerChoices = _.cloneDeep(answerChoicesToInsert);

		if ((statementsToInsert.length >= 2) && (answerChoicesToInsert.length >= 2)) {
			setIsSaving(true);
			try {
				const response = await axios.post(`/matrixes`,
					JSON.stringify(json),
					{
						headers: { 'Content-Type': 'application/json' }
					}
				);



				questionId = response.data.questionId;

				parseResponse(response);

				navigate(`/matrix/edit/${questionId}`, { replace: true });

			} catch (err) {
				console.log(err);
				// if (!err?.response) {
				//     setErrMsg('No Server Response');
				// } else if (err.response?.status === 409) {
				//     setErrMsg('Email Taken');
				// } else {
				//     setErrMsg('Registration Failed')
				// }
				// errRef.current.focus();
			}

		}

	}

	useEffect(() => {

		if (questionId === undefined) {
			return;
		}

		let isMounted = true;

		const controller = new AbortController();

		const getMatrix = async () => {

			setIsSaving(true);

			try {
				console.log(`questionId: ${questionId}`);
				const response = await axios.get(`/matrixes/${questionId}`, {
					signal: controller.signal
				});
				console.log(response.data);
				if (isMounted) {
					parseResponse(response);
				}
			} catch (err) {
				if (isMounted) {
					console.error(err);
					// if (err.response?.status === 403) {
					//     navigate('/login', { state: { from: location }, replace: true });
					// }
				}
			}
		}

		getMatrix();

		return () => {
			isMounted = false;
			controller.abort();
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		let i, l, active, valid;

		active = 0;
		valid = 0;

		for (i = 0, l = statements.length; i < l; i++) {
			if (statements[i].deleted !== true) {
				active++;
				if (validTextRegex.test(statements[i].text)) {
					valid++;
				}
			}
		}
		setActiveStatements(active);
		setValidStatements(valid);

	}, [statements]);

	useEffect(() => {
		let i, l, active, valid;

		active = 0;
		valid = 0;

		for (i = 0, l = answerChoices.length; i < l; i++) {
			if (answerChoices[i].deleted !== true) {
				active++;
				if (validTextRegex.test(answerChoices[i].text)) {
					valid++;
				}
			}
		}
		setActiveAnswerChoices(active);
		setValidAnswerChoices(valid);

	}, [answerChoices]);

	useEffect(() => {
		setValidQuestion(validTextRegex.test(text));
	}, [text]);

	if (!dataLoaded) {
		return <LoadingModal />;
	}

	console.log(`EditMatrix: render at ${new Date().getTime()}`);

	return (
		<section className={styles.admin}>

			<p><Link to="/admin">Admin</Link> &gt; <Link to="/questions">Questions</Link></p>

			<h3 className={styles.noBorder}>{(questionId === undefined) ? "New matrix" : "Matrix"} question</h3>

			<input type="text" name="question" autoComplete="off" autoFocus={true} maxLength="500" placeholder="Who is your favorite Red Sox player?" value={text} onChange={e => setText(e.target.value)} />

			<h3>Status:</h3>

			<div className="radio-button-and-label">
				<input type="radio" id="active" name="status" value="active" onChange={(e) => setStatus(e.target.value)} checked={status === "active"} />
				<label htmlFor="active">Active</label>
			</div>

			<div className="radio-button-and-label">
				<input type="radio" id="archived" name="status" value="archived" onChange={(e) => setStatus(e.target.value)} checked={status === "archived"} />
				<label htmlFor="archived">Archived</label>
			</div>

			<div className="radio-button-and-label">
				<input type="radio" id="deleted" name="status" value="deleted" onChange={(e) => setStatus(e.target.value)} checked={status === "deleted"} />
				<label htmlFor="deleted">Deleted</label>
			</div>

			{/* <label htmlFor="priority">Priority (5: highest, 1: lowest)</label>
            <select name="priority" value={priority} onChange={(e) => setPriority(parseInt(e.target.value, 10))}>
                <option value="5">5 (Highest)</option>
                <option value="4">4 (High)</option>
                <option value="3">3 (Moderate)</option>
                <option value="2">2 (Low)</option>
                <option value="1">1 (Lowest)</option>
            </select> */}

			{/* <div className="checkbox-and-label" style={{ marginTop: '1rem' }}>
                <input type="checkbox" id="feature" name="feature" onChange={(e) => setFeature(e.target.checked)} checked={feature} />
                <label htmlFor="feature">Feature this question on a dashboard</label>
            </div> */}

			{/* <div className="checkbox-and-label" style={{ marginTop: '1rem' }}>
                <input type="checkbox" id="shuffleCheckbox" name="shuffleCheckbox" onChange={(e) => setShuffleStatements(e.target.checked)} checked={shuffleStatements} />
                <label htmlFor="shuffleCheckbox">Randomize (shuffle) the order of statements</label>
            </div> */}

			<h3 className={styles.noBorder}>Matrix statements (rows):</h3>

			<div className="dndContainer">
				<DragDropContext onDragEnd={handleStatementOnDragEnd}>
					<Droppable droppableId="statements">
						{(provided) => (
							<div className="optionsGroup" {...provided.droppableProps} ref={provided.innerRef}>
								{
									statements.map((statement, i) => {
										return (
											<Draggable key={i} draggableId={i.toString()} index={i}>
												{(provided) => (
													<div className="optionGroup" {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
														<input key={i} type="text" autoComplete="off" maxLength="500" placeholder={`Statement ${i + 1}`} disabled={statement.deleted} value={statement.text} onChange={e => onStatementChange(i, e.target.value)} />
														<button className="delete" onClick={e => onDeleteStatement(i)}></button>
													</div>
												)}
											</Draggable>
										)
									})
								}
								{provided.placeholder}
							</div>
						)}
					</Droppable>
				</DragDropContext>
				<button onClick={e => onAddStatement()} disabled={activeStatements >= 10} >Add new statement (row)</button>
			</div>

			<h3 className={styles.noBorder}>Matrix answer choices (columns):</h3>

			<div className="dndContainer">
				<DragDropContext onDragEnd={handleAnswerChoiceOnDragEnd}>
					<Droppable droppableId="answerChoices">
						{(provided) => (
							<div className="optionsGroup" {...provided.droppableProps} ref={provided.innerRef}>
								{
									answerChoices.map((answerChoice, i) => {
										return (
											<Draggable key={i} draggableId={i.toString()} index={i}>
												{(provided) => (
													<div className="optionGroup" {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
														<input key={i} type="text" autoComplete="off" maxLength="500" placeholder={`Answer choice ${i + 1}`} disabled={answerChoice.deleted} value={answerChoice.text} onChange={e => onAnswerChoiceChange(i, e.target.value)} />
														<button className="delete" onClick={e => onDeleteAnswerChoice(i)}></button>
													</div>
												)}
											</Draggable>
										)
									})
								}
								{provided.placeholder}
							</div>
						)}
					</Droppable>
				</DragDropContext>
				<button onClick={e => onAddAnswerChoice()} disabled={activeAnswerChoices >= 7}>Add new answer choice (column)</button>
			</div>
			<button disabled={!validQuestion || (validAnswerChoices < 2) || (validStatements < 2) || isSaving} onClick={saveChanges}>Save changes</button>

		</section>
	);

};

export default EditMatrix;